var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showBanner && _vm.hasWhatsappV3Channel && !_vm.isExpired
    ? _c(
        "div",
        { staticClass: "whatsapp-v3-warning-wrapper" },
        [
          _c("transition", { attrs: { name: "slide-down" } }, [
            _vm.bannerVisible
              ? _c("div", { staticClass: "whatsapp-v3-warning-banner" }, [
                  _c("div", { staticClass: "banner-main" }, [
                    _c(
                      "div",
                      {
                        staticClass: "banner-content",
                        on: {
                          click: function ($event) {
                            _vm.showDetailModal = true
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "material-icons warning-icon" },
                          [_vm._v("warning")]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "banner-text" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$t("message.whatsappV3BannerWarning")
                              ) +
                              "\n                    "
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "close-btn",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.closeBanner.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v("close"),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "progress-bar-container" }, [
                    _c("div", {
                      staticClass: "progress-bar",
                      style: { width: _vm.progressWidth + "%" },
                    }),
                  ]),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "a-modal",
            {
              staticClass: "whatsapp-v3-detail-modal",
              attrs: {
                visible: _vm.showDetailModal,
                footer: null,
                closable: true,
                width: "600px",
                centered: "",
              },
              on: { cancel: _vm.closeDetailModal },
              scopedSlots: _vm._u(
                [
                  {
                    key: "title",
                    fn: function () {
                      return [
                        _c("div", { staticClass: "modal-title" }, [
                          _c(
                            "span",
                            {
                              staticClass: "material-icons",
                              staticStyle: {
                                color: "#f5a623",
                                "margin-right": "8px",
                              },
                            },
                            [_vm._v("warning")]
                          ),
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("message.whatsappV3ModalTitle")) +
                              "\n            "
                          ),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                2741473432
              ),
            },
            [
              _vm._v(" "),
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "warning-section" }, [
                  _c("div", { staticClass: "section-header" }, [
                    _c("span", { staticClass: "material-icons" }, [
                      _vm._v("error_outline"),
                    ]),
                    _vm._v(" "),
                    _c("h3", [
                      _vm._v(
                        _vm._s(_vm.$t("message.whatsappV3ServiceStatusHeading"))
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(_vm._s(_vm.$t("message.whatsappV3ServiceStatusP1"))),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(_vm._s(_vm.$t("message.whatsappV3ServiceStatusP2"))),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-section" }, [
                  _c("div", { staticClass: "section-header" }, [
                    _c("span", { staticClass: "material-icons" }, [
                      _vm._v("info"),
                    ]),
                    _vm._v(" "),
                    _c("h3", [
                      _vm._v(_vm._s(_vm.$t("message.whatsappV3WaIdHeading"))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(_vm.$t("message.whatsappV3WaIdP1")))]),
                  _vm._v(" "),
                  _c("p", { staticClass: "highlight-text" }, [
                    _vm._v(_vm._s(_vm.$t("message.whatsappV3WaIdP2"))),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "action-section" },
                  [
                    _c(
                      "a-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.goToChannelSettings },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "material-icons",
                            staticStyle: {
                              "font-size": "18px",
                              "margin-right": "4px",
                            },
                          },
                          [_vm._v("settings")]
                        ),
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.$t("message.whatsappV3GoChannelSettings")
                            ) +
                            "\n                "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("a-button", { on: { click: _vm.closeDetailModal } }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("message.whatsappV3Understood")) +
                          "\n                "
                      ),
                    ]),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }